import {Component, OnDestroy} from '@angular/core';
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {ActivatedRoute, Router} from "@angular/router";
import {CommonService} from "../../../../shared/services/common.service";
import {FetchSessionListRequest, UpdateSessionDetailsRequest} from "../../core/sessions-list.actions";
import {sessionList} from "../../core/sessions-list.selectors";
import {Subject, takeUntil} from "rxjs";
import {SessionRescheduleComponent} from "../session-reschedule/session-reschedule.component";
import {drillDownUrls, profileData} from "../../../../shared/core/shared.selectors";
import {SetDrillDownUrls} from "../../../../shared/core/shared.actions";

@Component({
  selector: 'app-sessions-list-table',
  templateUrl: './sessions-list-table.component.html',
  styleUrls: ['./sessions-list-table.component.css']
})
export class SessionsListTableComponent implements OnDestroy {
  groupId: string;
  loading: boolean = false;
  role: number;
  backToPopup: any;
  sessionId: any;
  sessionFormatLabelMap = {
    valid: [1, 2],
    1: 'Group',
    2: 'Individual'
  };
  dataSource: any;
  displayedColumns = [
    'session',
    'description',
    'date',
    'startTime',
    'duration',
    'format',
    'locationName',
    'attendance',
    'actionMenu',
  ];
  actionMenuForCloseSession = [
    {
      displayName: 'Reschedule',
      highLightColor: '',
      handleClick: (data) => this.handleRescheduleOption(data)
    },
    // {
    //   displayName: 'Close Session',
    //   highLightColor: '',
    //   handleClick: (data) => this.handleCloseSessionOption(data)
    // }
  ];
  actionMenuForRestartSession = [
    {
      displayName: 'Reschedule',
      highLightColor: '',
      handleClick: (data) => this.handleRescheduleOption(data)
    },
    // {
    //   displayName: 'Restart Session',
    //   highLightColor: '',
    //   handleClick: (data) => this.handleRestartSessionOption(data)
    // }
  ]
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private router: Router,
  ) {
    this.backToPopup = this.route.snapshot.queryParamMap.get('backToPopup');
    this.sessionId = this.route.snapshot.queryParamMap.get('sessionId');

    this.groupId = this.route.snapshot.paramMap.get('groupId');
    if (this.groupId) {
      const payload = {
        groupId: this.groupId,
      };
      this.store.dispatch(FetchSessionListRequest({payload}));

      this.store.select(sessionList)
        .pipe(takeUntil(this.onDestroy))
        .subscribe(data => {
          this.dataSource = data.list.map((d, i) => {
            return {
              ...d,
              prevDate: data.list[i - 1]?.meetingOn || null,
              nextDate: data.list[i + 1]?.meetingOn || null
            }
          });
          this.loading = data.loading;
          if (this.backToPopup) {
            const selectedSession = this.dataSource?.find((item) => item?.sessionNumber == this.sessionId);
            if (selectedSession) {
              this.handleRescheduleOption(selectedSession);
              this.backToPopup = false;
            }
            this.commonService.updateQueryParams({
              'backToPopup': null,
              'sessionId': null
            });
          }
        });
    }

    this.store.select(profileData)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.role = data.profile?.role;
      });
  }

  ngOnInit() {
    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }
        const prevUrlParams = this.commonService.urlParams.getValue();

        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });
  }

  handleRescheduleOption(data) {
    this.commonService.openDialog({
      data: {
        component: SessionRescheduleComponent,
        data,
        groupId: this.groupId,
        role: this.role
      }
    })
  }

  handleCloseSessionOption(data) {
    const payload = {
      isComplete: true,
      groupId: +this.groupId,
      sessionId: data.sessionNumber
    }
    this.store.dispatch(UpdateSessionDetailsRequest({payload, isSessionList: true}));
  }

  handleRestartSessionOption(data) {
    const payload = {
      isComplete: false,
      groupId: +this.groupId,
      sessionId: data.sessionNumber
    }
    this.store.dispatch(UpdateSessionDetailsRequest({payload, isSessionList: true}));
  }

  handleSessionClick(data) {
    if (data?.sessionNumber) {
      this.store.select(drillDownUrls).subscribe(data => {
        const updatedDrillDownUrls = [...data, this.router.url];
        if ([...data].pop() !== this.router.url) {
          this.store.dispatch(SetDrillDownUrls({payload: updatedDrillDownUrls}));
        }
      }).unsubscribe();

      const urlPrefix = this.router.url.split('/')[1];
      this.router.navigate([`/${urlPrefix}/group/${this.groupId}/sessions/${data?.sessionNumber}/details`]);
    }
  }


  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
